module.exports = __webpack_public_path__ + "img/middle-background.898d3326.jpg";